/**
 * @Author: Zangkang
 * @Date:   2018-02-25T20:55:02+08:00
 * @Last modified by:

 * @Last modified time: 2018-02-26T15:34:05+08:00
 */
import keyMirror from "keymirror";

export const Attendance = {
   ActionTypes: keyMirror({
     // common
     FETCHDATA: null,
     FETCHSUCCESS: null,
     FETCHFAILURE: null,
     CREATESUCCESS: null,
     CREATEFAILURE: null,
     UPDATESUCCESS: null,
     UPDATEFAILURE: null,
     DELETESUCCESS: null,
     DELETEFAILURE: null,
    // attendance schedule
    CHANGEATTENDANCETEMPLATE: null,
    FETCHATTENDANCESCHEDULESUCCESS: null,
    UPDATEATTENDANCESCHEDULESUCCESS: null,
    FETCHATTENDANCESCHEDUSCHEDULEUCCESS:null,
     // annual live
     FETCHANNUALLEAVEDATA: null,
     FETCHANNUALLEAVESUCCESS: null,
     FETCHANNUALLEAVEFAILURE: null,
     EXPORTANNUALLEAVESUCCESS: null,
     EXPORTANNUALLEAVEFAILURE: null,
     UPDATEANNUALLEAVESUCCESS: null,
     UPDATEANNUALLEAVEFAILURE: null,

     //attendance template
     FETCHATTENDANCETEMPLATESUCCESS:null,
     UPDATEATTENDANCETEMPLATESUCCESS:null,
     INITIALIZATIONSUCCESS:null,

     // company calendar
     FETCHCOMPANYCALENDARLISTSUCCESS: null,
     // crew rostering
     FETCHCREWROSTERINGLISTSUCCESS: null,
     UPDATEATCREWROSTERINGSUCCESS: null,
     EXPORTCREWROSTERINGSSUCCESS:null,
     UPDATESCHEDULESUCCESS: null,
     //  attendance record
    FETCHATTENDANCERECORD:null,
    FETCHEXCEPTIONATTENDANCERECORD:null,
    UPDATEATTENDANCERECORDSUCCESS:null,
    EXPORTATTENDANCERECORDSSUCCESS:null,
    EXPORTATTENDANEXCEPTIONCERECORDSSUCCESS:null,
    // vacation management
    CHANGEVACATIONMANAGEMENT: null,
    SELECTVACATIONMANAGEMENT: null,
    UPDATEVACATIONMANAGEMENT: null,
   })
};



// WEBPACK FOOTER //
// ./src/constants/attendance-constants.js